export enum ProfileType {
    Current = 1,
    Custom = 2,
    Expiration = 4,
}